import { produce } from 'immer';
import { DEFAULT_TYPOGRAPHY } from 'utils/constants';
import { DEFAULT_EVENT_STYLES } from 'utils/appDesignerConstants';
import * as types from './eventWrapperTypes';
import createReducer from '../../utils/createReducer';

const initialState = {
    themeColors: DEFAULT_EVENT_STYLES.themeColors.light,
    fontStylesWithFontFamily: {
        h1: 'serif',
        h2: 'serif',
        h3: 'serif',
        h4: 'serif',
        h5: 'serif',
        h6: 'serif',
        h7: 'serif',
    },
    typography: DEFAULT_TYPOGRAPHY,
    pageId: '',
    eventId: '',
    pageDetail: {
        name: '',
        isShowTitle: false,
    },
    profiles: [],
    sessionSpeakerProfile: '',
    editAttendeeProfile: '',
    timezone: '',
    isChatActive: false,
    isUserHasChatAccess: false,
    chatBlacklistedUsers: [],
};

const actionHandlers = {
    [types.UPDATE_EVENT_DETAILS]: produce((draft, { eventWrapperData }) => {
        draft.themeColors = eventWrapperData.themeColors;
        draft.typography = eventWrapperData.typography;
        draft.fontStylesWithFontFamily =
            eventWrapperData.fontStylesWithFontFamily;
        draft.pageId = eventWrapperData.pageId;
        draft.eventId = eventWrapperData.eventId;
        draft.pageDetail = eventWrapperData.pageDetail;
        draft.profiles = eventWrapperData.profiles;
        draft.sessionSpeakerProfile = eventWrapperData.sessionSpeakerProfile;
        draft.editAttendeeProfile = eventWrapperData.editAttendeeProfile;
        draft.timezone = eventWrapperData?.timezone;
        draft.isChatActive = eventWrapperData?.isChatActive;
        draft.isUserHasChatAccess = eventWrapperData?.isUserHasChatAccess;
        draft.chatBlacklistedUsers = eventWrapperData?.chatBlacklistedUsers;
        draft.eventStyles = eventWrapperData?.eventStyles;
    }),

    [types.UPDATE_EVENT_STYLE_PREVIEW]: produce(
        (draft, { themeColors, typography }) => {
            if (themeColors) draft.themeColors = themeColors;
            if (typography) draft.typography = typography;
        }
    ),

    [types.UPDATE_PAGE_DETAIL_PREVIEW]: produce((draft, { pageDetail }) => {
        if (pageDetail) {
            if (pageDetail.name !== undefined)
                draft.pageDetail.name = pageDetail.name;
            if (pageDetail.isShowTitle !== undefined)
                draft.pageDetail.isShowTitle = pageDetail.isShowTitle;
        }
    }),

    [types.RESET_EVENT_DETAILS]: () => 
        // Return a fresh copy of initialState instead of trying to mutate draft
         ({ ...initialState })
    ,
};

export default createReducer(initialState, actionHandlers);
